<template>
    <div class="p-3 fs-small">

        <h1>Privacy Policy</h1>
        <H5>Effective Date of Current Policy: May 25, 2018</H5>

        <p>
            PLURALO is a shared online platform, managed by Capitães da Areia,lda (forward “Pluralo”), NIPC 514256826, with the registered headquarters at Passeio dos Oceanos - Quinta da Orada, Lote 3, Loja 24 8200-394 Albufeira (PORTUGAL) and registration number NIPC 514256826, is a company that optimizes the partnership / commercial relationship between Agent Reseller, sellers of tourist activities, and companies/professional providers of these same tourist activities, promoting the daily management of operations through the website www.pluralo.com, where its WEBSITE is hosted.
        </p>

        <center>
            <br>PLURALO IS FULLY DEDICATED WITH THE PROTECTION OF THE PRIVACY AND PERSONAL DATA OF ITS CUSTOMERS AND USERS FROM THE WEBSITE, FOR WHICH IT HAS BEEN PREPARED AND HAS ADOPTED THE PRESENT POLICY AND THE PRACTICES DESCRIBED HEREIN. THIS PRIVACY POLICY EXPLAINS HOW YOUR PERSONAL DATA ARE COLLECTED AND TREATED BY WHICH WE ADVISE YOUR READING TO KNOW THE CONDITIONS YOUR PERSONAL DATA ARE COLLECTED AND USED.
        </center>

        <h3>Transparency - Types of Information Collected</h3>
        <p>
            The types of Personal Information we collect (directly from you or from third-party sources) and our privacy practices depend on the nature of your relationship with Pluralo and the requirements of applicable law. Some of the ways that Pluralo may collect Personal Information include:
            Providing the user with personal information directly to Pluralo through interaction with the Services, participating in surveys, during events such as sweepstakes and requesting services or information.
            As you navigate the Services, certain passive information may also be recorded about your visit, including through cookies and similar technologies, as described below.
            Pluralo seeks to collect only information relevant to the purposes of Processing.
        </p>

        <h3>WHAT IS THE PRIVACY POLICY?</h3>
        <p>
            This Privacy Policy explains how we collect and process the personal data that is necessary for the provision of services that are available through the WEBSITE.<br>
            Examples of such services are the registration of users for service providers or the subscription of newsletters.<br>
            The aim is for these services to be provided in an expeditious and undisturbed way, describing the practices adopted for this purpose.
        </p>

        <h3>WHAT ARE PERSONAL DATA?</h3>
        <p>
            Personal data is any information relating to a person that identifies that person or makes it identifiable, regardless the nature and support of the information and including the sound and image of the person.<br>
            Examples of personal data that are recorded: name, phone contact, email, phone country.<br>
            By identifiable means a person who can be identified, directly or indirectly, in particular by reference to an identification number or other specific elements of his or her physical, physiological, psychic, economic, cultural or social identity.
        </p>

        <h3>HOW DO WE USE YOUR PERSONAL DATA?</h3>
        <p>
            PLURALO will use the personal data you provide us for the following purposes:
            <ul>
                <li>To deal with your registration in PLURALO;</li>
                <li>To manage its activity in PLURALO;</li>
                <li>To analyze and respond to your messages, customer support and requests for information regarding.</li>
                <li>In order to send newsletters or other publications that you have requested and/or may be of interest to you;</li>
                <li>For the operation and management of the WEBSITE;</li>
                <li>To keep track of your contact details;</li>
                <li>For comercial purposes, such as data analysis, audits;</li>
                <li>For the prevention of fraud;</li>
                <li>For the adaption, improvement and modification of services, in particular y identifying trends in use, or to determine the effectiveness of promotional campaigns;</li>
                <li>For the expansion of PLURALO’s commercial activities</li>
            </ul>
        </p>

        <p>
            These personal data processing operations are na essential tool for your satisfaction and for the activity of PLURALO and are carried out according to the applicable legislation and according to the best practices.</p>
            Your personal data will not be reused for the other purposes that are previously identified or that have nothing to do with those purposes for which they were initially collected.
        </p>

        <h3> Registered Information Type </h3>
        <p>
            Pluralo treats personal information of its customers, users and visitors to its sites (collectively "natural persons").
            Information that the user provides directly to Pluralo. When you use the Services or engage in certain activities, such as registering an account with Pluralo, responding to inquiries, requesting services or information, or contacting us directly, we may request that you provide some or all of the following types of information:

            <li><b>Direct Communications.</b> We may treat your personal information, such as an e-mail address, when the user chooses to request information about our Services, register with the Pluralo newsletter or fidelity we can offer from time to time, request to receive customer or technical support or if the user communicate with us.</li>
            <li><b>Searches</b> From time to time, we may contact you to participate in online surveys. If you decide to participate, you may be required to provide certain information that may include Personal Information. All information collected from your participation in our surveys is provided voluntarily by you. We may use such information to improve products, sites and / or services and in any manner consistent with the policies provided herein.</li>
            <li><b>Publications on the WEBSITE</b> Pluralo may offer publicly accessible pages, blogs, private messages or community forums. You should be aware that by posting information on these pages, blogs, private messages and community forums, the Website will record the information you provide in those submissions, including any Personal Information. If you choose to submit content to any public area of ​​the Website, that content will be deemed "public" and will not be subject to the privacy protections set forth herein.</li>
            <li><b>Registration for sweepstakes or contests</b> Occasionally, Pluralo may run sweepstakes and contests. We ask those who enter the sweepstakes or contests to provide contact information (for example, an email address). If the user participates in a sweepstakes or contest, his or her contact information may be used to contact himself / herself about sweepstakes or contests and for other promotional, marketing and commercial purposes. All Sweepstakes / Contest entry forms will</li> provide a way for participants to opt out of receiving communications that are not related to awarding prizes.
            <li><b>Automatic Data Logging</b> We may collect certain information automatically through our Services or other web analytics methods, defined herein as "Analytics", cookie identifiers, mobile advertising identifiers, address MAC, IMEI, Advertiser ID, and other device identifiers. automatically assigned to your computer or device when accessing the Internet, browser type and language, geolocation information, type of hardware, operating system, Internet service provider, pages visited before and after using the Services, date and time the amount of time you spend on each page, information about the links you click on and the pages you view on the Services, and other actions taken while using the Services, such as preferences. If you are not the account holder when this information is collected, we may subsequently assign this information to your account if and when you create one. </li>
        </p>

        <h3>WHAT IS THE FOUNDATION TO TREAT THE PERSONAL DATA WE COLLECT?</h3>
        <p>
            The personal data that PLURALO treats has specific foundations depending on the purpose for which they are intended.<br>
            In the following table you can see the reasons for the above purposes:
        </p>

        <table>
            <tr>
                <th width="50%">PURPOSE</th>
                <th width="50%">BASIS</th>
            </tr>
            <tr>
                <td>To handle your registration in PLURALO and create user profiles</td>
                <td>Consent for this specific purpose.</td>
            </tr>
            <tr>
                <td>To manage your activity in PLURALO</td>
                <td>Execution of the contract with PLURALO.</td>
            </tr>

            <tr>
                <td>To analyze and answer to your messages, customer support and inquiries</td>
                <td>Consent for this specific purpose;</td>
            </tr>
            <tr>
                <td>In order to send newsletters or other publications that you have requested and / or that may be of interest to you</td>
                <td>Consent for this specific purpose.</td>
            </tr>
            <tr>
                <td>For operations and management of WEBSITE.</td>
                <td>Legitimate interests pursued by PLURALO.</td>
            </tr>
            <tr>
                <td>To keep track of your contact details</td>
                <td>Legitimate interests pursued by PLURALO.</td>
            </tr>
            <tr>
                <td>For commercial purposes, such as data analysis, audits</td>
                <td>Legitimate interests pursued by PLURALO.</td>
            </tr>
            <tr>
                <td>For fraud prevention</td>
                <td>Legitimate interests pursued by PLURALO.</td>
            </tr>
            <tr>
                <td>Para prevenção de fraudes</td>
                <td>Interesses legítimos prosseguidos pela PLURALO.</td>
            </tr>
            <tr>
                <td>For the adaptation, improvement and modification of services, in particular by identifying trends in use, or to determine the effectiveness of promotional campaigns</td>
                <td>Legitimate interests pursued by PLURALO.</td>
            </tr>
            <tr>
                <td>For the expansion of PLURALO's commercial activities.</td>
                <td>Legitimate interests pursued by PLURALO.</td>
            </tr>
        </table>

        <h3>WHAT PERSONAL DATA IS COLLECT?</h3>
        <p>
            The personalo data that PLURALO collects and treats are only those that are necessaru and suitable for the purposes indicated above.<br>
            PLURALO will collect and process the following personal data:
            <table>
                <tr>
                    <th width="50%">PURPOSE</th>
                    <th width="50%">DATA</th>
                </tr>
                <tr>
                    <td>PLURALO will collect and process the following personal data:</td>
                    <td>"Identification as Agent"; "Identification as a Service Provider"; "Name"; "residence"; "NIF"; "Title of the natural person who registers"; "E-mail"; "Password" and "Facebook data through the plugin".</td>
                </tr>
                <tr>
                    <td>For your access to PLURALO</td>
                    <td>“E-mail"; "Password"; "Facebook data through the plugin".</td>
                </tr>
                <tr>
                    <td>For the creation of a Service Provider Profile</td>
                    <td>"Professional Profile"; "Services Offered"; "URL to access the website online"; "E-mail address"; "Contact telephone"; "Country;" "Profile Picture"; and "Description of services provided".</td>
                </tr>
                <tr>
                    <td>To create a Service Provider Profile</td>
                    <td>"Name"; "Photography"; "Parents"; "E-mail address"; "Contact telephone"; "Country;" "Profile Picture".</td>
                </tr>
                <tr>
                    <td>To analyse and respond to your messages, customer support and inquiries</td>
                    <td>"Identification as Agent"; "Identification as a Service Provider"; "Name"; "E-mail".</td>
                </tr>
                <tr>
                    <td>In order to send newsletters or other publications that you have requested and / or that may be of interest to you</td>
                    <td>"Name"; "residence"; "Title of the natural person who registers"; "E-mail".</td>
                </tr>
            </table>
        </p>

        <h3>HOW DO WE COLLECT YOUR PERSONAL DATA?</h3>
        <p>
            We collect your personal data through the forms presente on the WEBSITE, but also through the WEBSITE and the communication thet it makes with its equipment and e-mail messages that it sends us.<br>
            Your personal data is collectd through your equipment as follows:

            <li>Through your registration</li>
            <li>By subscribing to the newsletter;</li>
            <li>Through your browser;</li>
            <li>By means of cookies;</li>
            <li>Through pixel tags and other similar technologies; </li>
            <li>IP address;</li>
            <li>Through your User data.</li>


            <p>
                PLURALO undertakes to treat its data in accordance with the law and legitimately<br>
                PLURALO will not sell, rent or share your personal data with third parties, except in cases clearly identified in this Privacy Policy (see Point 11 to understand how).<br>
                The services of PLURALO are not addressed to minors, and personal data of minors are not intentionally treated.
            </p>

        </p>

        <h3> COOKIES, PIXEL TAGS, STATISTICAL INFORMATION AND TOOLS OF COMMUNICATION AND MARKETIGN OF INTEREST </h3>
        <p>
            <li> <b> Google Analytics </b> Pluralo may use the Google Analytics Demographics and Interest Report and Google Analytics to handle information about visitor behavior and visitor demographics in some of our Services and to develop website content. This analysis data is not linked to any personal information. For more information about Google Analytics, visit https://www.google.com/policies/privacy/partners.</li>
            <li> <b> Intercom </b> We use Intercom (https://www.intercom.com) to facilitate communication, customer support, maintenance of information and collection of publicly available information about our customers and users . For more information about Intercom's services, visit https://interconnect.com. </p></li>
            <li> <b> Cookies </b> Cookies are small information files that help you identify your browser and can store information, for example, User settings and preferences. PLURALO will store cookies on your device to personalize and facilitate browsing as well as troubleshooting, statistics, quality assurance, and to monitor system security. With the exception of cookies specifically required for the performance of the website, the storage of other cookies will always depend on the acceptance and consent of the User, and this consent may be withdrawn at any time through specific browser tools.</li>
            <li> <b> Pixel Tags </b> Pixel tags (also known as web beacons and clear GIFs) can be used in connection with some services to, for example, track the actions of users of the services (including email recipients ), measure the success of our marketing campaigns, and compile statistics on the use of the Services and response rates.</li>

            <h3> HOW WE PROTECT YOUR PERSONAL DATA </h3>
            <p>
                Your personal data is kept safe by the adoption of various security measures, technical (data is kept on secure servers using tools and technology MICROSOFT that offers us all the security guarantees) and organizational (only access to the data the employees and the processes that must access them according to rules created for that purpose) that allow to protect the personal data against its diffusion, loss, misuse, alteration, treatment or unauthorized access and, in any other way of illicit treatment.
                In order to protect your personal data, we only use data center providers who provide us with adequate and documented security measures, namely that your personal data is stored on servers that are kept in controlled environments with limited access.
                Similarly, when browsing the WEBSITE, we protect your data with encryption, such as Transport Layer Security (TLS), and your password is stored using a unidirectional hash , that is, it can not be retrieved (or disclosed) by any person, including PLURALO, and can only be redefined.
                While we take the precautions and precautions that we deem appropriate to protect the personal data you provide to us and collect, you must be aware that no security system is impenetrable.
                Therefore, you should take certain precautions, such as keeping your password secret and not divulging it to any other person; If you believe that your password has been misused, you should let us know right away; you should also be careful to start and end the session every time the browser closes.
            </p>
        </p>

        <h3>HOW LONG DO WE KEEP YOUR PERSONAL DATA?</h3>
        <p>
            Your personal data will be kept for the time necessary for the purposes for which they are intended, as set forth in this Privacy Policy. Like this:
        </p>
        <table>
            <tr>
                <th width="50%">PURPOSE</th>
                <th width="50%">DURATION</th>
            </tr>
            <tr>
                <td>To handle your registration in PLURALO and create user profiles</td>
                <td>Duration of the contract plus one year after its expiry</td>
            </tr>
            <tr>
                <td>To manage your activity in PLURALO</td>
                <td>Duration of the contract plus one year after its expiry </td>
            </tr>
            <tr>
                <td>To analyze and respond to your messages, customer support and inquiries</td>
                <td>Duration of the contract plus one year after its expiry</td>
            </tr>
            <tr>
                <td>In order to send newsletters or other publications that you have requested and / or that may be of interest to you</td>
                <td>Duration of the contract</td>
            </tr>
            <tr>
                <td>For operations and management of the WEBSITE;</td>
                <td>Duration of the contract</td>
            </tr>
            <tr>
                <td>To keep track of your contact details;</td>
                <td>Duration of the contract.</td>
            </tr>
            <tr>
                <td>For commercial purposes, such as data analysis, audits;</td>
                <td>Duration of the contract.</td>
            </tr>
            <tr>
                <td>For fraud prevention;</td>
                <td>Duration of the contract plus one year after its expiry</td>
            </tr>
            <tr>
                <td>For the adaptation, improvement and modification of services, in particular by identifying trends in use, or to determine the effectiveness of promotional campaigns;</td>
                <td>Duration of the contract.</td>
            </tr>
            <tr>
                <td>For the expansion of PLURALO's commercial activities.</td>
                <td>Duration of the contract.</td>
            </tr>
        </table>

        <p>
            If any specific or mandatory period of time is required by law, the period of retention of the data will be the same. In all other cases, the personal data will be kept at the maximum during the above mentioned times, periods that PLURALO understands as sufficient to fulfill the purposes<br>
            At the end of the storage period, all personal data collected will be deleted.
        </p>

        <h3>HOW CAN YOU EXERCISE YOUR RIGHTS:</h3>
        <p>
            Before we explain how you can exercise your rights, you should know what they are. Thus, the legislation grants you the right to request us, as the person responsible for the processing , (a) access to personal data concerning you, as well as your (b) rectification or deletion, and d) limitation of the treatment with respect to it, or the right to (e) oppose processing, as well as the right to (f) portability of data. You also have the right to submit a complaint to a supervisory authority (Portuguese National Data Protection Commission - www.cnpd.pt)<br>
            What each of these rights means:
            <ul>
                <li> <b> Access: </b> The right to obtain confirmation that the personal data concerning you are processed and, if applicable, the right to access your personal data;</li>
                <li> <b> Rectification: </b> The right to have rectification of inaccurate personal data concerning you and your incomplete personal data completed;</li>
                <li> <b> Deletion: </b> the right to obtain the erasure of your personal data when one of the reasons listed in the legislation applies;</li>
                <li> <b> Limitation of treatment: </b> The right to limit treatment if one of the situations listed in the legislation applies;</li>
                <li> <b>Opposition: </b> othe right to object at any time to the processing of personal data concerning him;</li>
                <li> <b> Portability: </b> the right to receive personal data concerning you in a structured, current and automatic reading format.</li>
            </ul>

        </p>

        You also have the right to submit a complaint to a supervisory authority (Portuguese National Data Protection Commission at www.cnpd.pt)<br>
        For the purpose of exercising the above rights you should contact PLURALO through the appropriate contact form.<br>
        If you ask us to delete some or all of your personal data, some of the requested services may not be provided to you, and PLURALO will keep the personal data necessary to fulfill your legal obligations.


        <h3>WHEN DO WE COMMUNICATE DATA TO THIRD PARTIES? </h3>
        <p>PLURALO may use third parties to provide certain services, such as maintenance, technical support, marketing, billing or payment management, which may have access to some of the personal data, in particular, the data necessary for contractual purposes. </p>

        <p>
            PLURALO may use third parties to provide certain services, such as maintenance, technical support, marketing, billing or payment management, which may have access to some of the personal data, in particular, the data necessary for contractual purposes.<br>
            PLURALO ensures that the entities that have access to the data are credible and offer high guarantees of protection, never being transmitted data beyond what is necessary to provide the contracted service, but PLURALO remains responsible for the personal data made available.<br>
            For example, for the purposes of data center management, PLURALO uses [IDENTIFY] services.<br>
            PLURALO may also communicate its data to companies with whom PLURALO has commercial partnerships to create and offer benefits. However, we will only make such sharing with prior authorization from you.<br>
            PLURALO may also transmit data to third parties in the context of investigations, inquiries and judicial and / or administrative proceedings or of a similar nature, provided that it is duly ordered by a judicial order accordingly.
        </p>

        <h3>THIRD PARTIES.</h3>
        <p>The WEBSITE may contain links to other websites which may collect and process your personal data, and that treatment is the sole responsibility of the owners of these websites, and PLURALO does not take any responsibility for its policies and / or practices.</p>

        <h3>TRANSFERS OF DATA OUT OF THE EUROPEAN UNION. </h3>
        <p>If data transfers to third countries other than those belonging to the European Union or the European Economic Area occur, PLURALO will comply with the law, in particular as regards the suitability of the country of destination for the protection of personal data and the requirements are applicable to such transfers, and personal data are not transferred to jurisdictions that do not provide security and protection guarantees</p>

        <h3> THE MINORS</h3>
        <p>The WEBSITE is not intended for minors under the age of 16, so we request that these minors do not provide us with personal information through the WEBSITE, application, social media and social media or emails.</p>

        <h3>SENSITIVE PERSONAL DATA.</h3>
        <p>PLURALO is grateful that you do not send us any sensitive personal data, ie information revealing racial or ethnic origin, political opinions, religious or philosophical beliefs, trade union association, genetic information, biometric information, health or data relating to a natural person's sexual life or sexual orientation. This personal data will be deleted immediately.</p>

        <h3>SENSITIVE PERSONAL DATA</h3>
        <p>PLURALO is grateful that you do not send us any sensitive personal data, ie information revealing racial or ethnic origin, political opinions, religious or philosophical beliefs, trade union association, genetic information, biometric information, health or data relating to a natural person's sexual life or sexual orientation.</p>








        <h1>TERMS AND CONDITIONS</h1>

        <p>
            PLURALO is a shared online platform, managed by Capitães da Areia,lda (forward “Pluralo”), NIPC 514256826, with the registered headquarters at Passeio dos Oceanos - Quinta da Orada, Lote 3, Loja 24 8200-394 Albufeira (PORTUGAL) and registration number NIPC 514256826, is a company that optimizes the partnership / commercial relationship between Agent Reseller, sellers of tourist activities, and companies/professional providers of these same tourist activities, promoting the daily management of operations through the website www.pluralo.com, where its WEBSITE is hosted.
        </p>

        <p>
            PLURALO allows the user to view and configure all the settings and parameters that affect each reservation, including the Agent negotiation rate, the number of sales done by the Agent, and the possibility for the Agent to do direct reservations, creating
            a unique platform of communication between the Agent and the Service Provider. However, PLURALO does not process payments between parties involved in the commercial operation itself, it only provides the technological support for this purpose.
        </p>
        <p>
            When using PLURALO, the User accepts the following Terms and Conditions, including the additional and specific information that may be available, as well as other policies in the platform. If you do not want to accept these Terms and Conditions, you should
            not access PLURALO and / or use its associated features and services.<br>
            These Terms and Conditions are applicable to all users.
        </p>

        <p>
            When agreeing with these Terms and Conditions, the user declares that, by accessing features and services associated with PLURALO, has the legal age and / or legal capacity to, according to the Law, provide the consent and be contractually bound in the
            execution and provision of the functionalities and services of the platform.
        </p>

        <p>
            PLURALO has the right to refuse the supply of any functionalities and services of the platform to any person, for any reason, at any moment.
        </p>

        <p>
            PLURALO can update, modify or replace any part of these Terms and Conditions and policies associated with them, publishing those changes in an accessible channel for the user, PLURALO can notify the user of the occurrence of changes but is not responsible
            if the user don’t verify them.
        </p>

        <p>
            The access and continued use of PLURALO after publishing any updates, modifications or substitutions to the Terms and Conditions and policies associated with them, except the privacy policy, constitutes acceptance and agreement with such updates, modifications
            or substitutions.
        </p>


        <h3>PART I - GENERAL CONDITIONS</h3>

        <h3>1. Acceptance </h3>
        <p>
            The use of PLURALO and all the services associated are restricted by the acceptance of these Terms and Conditions, if you do not accept these Terms and Conditions, you will not be able to use the platform and the associated services.
        </p>
        <p>
            By agreeing with the Terms and Conditions, the user agrees on his own behalf and / or the organization that he represents, ensuring that he has the necessary authority to represent the company and perform that agreement.
        </p>

        <h3>2. Accuracy and Integrity</h3>
        <p>
            Users accept and acknowledge that PLURALO is not responsible for the accuracy and integrity of the information provided by Users on the platform, which may be inaccurate, incomplete or outdated.
        </p>


        <h3>3. Users</h3>
        <p>
            The Platform is accessible to two types of Users: Service Provider (Professionals Individuals or Collective Company); and Agents (sellers and resellers).
        </p>

        <p>
            By agreeing with the following Terms and conditions, the User declares that:
            <ul>
                <li>Individual: has the capacity for acceptance, being over 18 years of age;</li>
                <li>Collective: is the legal representative with the necessary authority, or authorized, for the creation of a User account to use the platform.</li>
            </ul>
        </p>

        <p>
            The violation of the previous paragraph means the immediate termination of this Agreement, without prejudice to any compensation that may be occurred in favor of PLURALO because of potential damages or losses that may have occurred as a result of false
            declarations.
        </p>

        <h3>4. Register</h3>
        <p>The User that intends to use PLURALO, must register by creating an account and completing the online registration process available at https://app.pluralo.com/signup.</p>
        <p>For the account creation the following data will be requested:
            <li>Agent/ Service Provider identification;</li>
            <li>Name/Firm, Residence/Headquarters, VAT/Register number and professional position of the individual that register; </li>
            <li>Email;</li>
            <li>Password.</li>
        </p>
        <p>The User can choose to register through Facebook, being bound by the terms of that platform.</p>
        <p>The User is responsible for the veracity, completeness and lawfulness of the data provided, as well as for its updating</p>
        <p>If registration is done by a representative of the User, PLURALO may request a document proving the necessary authority, and the User has to provide such proof as soon as possible.</p>



        <h3>5. Access </h3>
        <p>
            The User can access PLURALO through login with email and password.<br>
            PLURALO cannot access the password, being the User the only responsible for the protection and good use of the password, modifying it regularly, PLURALO does not have any responsibility for the improper use or loss of the password. In case of loss or forgetfulness of any access data to the platform, the User may request, through its own tool, its reinstatement or resubmission.
        </p>


        <h3>6.	Account </h3>
        <p>
            The User accepts that the access data to PLURALO can only be used by the User, and it is not allowed to share it by several people.
        </p>
        <p>
            The User must comply with good practices regarding the security of his account, by changing his password regularly and avoiding connections through networks open to the public.<br>
            PLURALO grants the account security within the expected and adequate security measures, having no liability other than that expressly provided for in Clause 12 of these Terms and Conditions.<br>
            The User is responsible for all the content inserted in the account, as well as all the activity that takes place in it, and there is no obligation by PLURALO to monitor the content or (un) fulfill any responsibility of the User, compliance with obligations to other Users or to national authorities.<br>
            The User acknowledges that PLURALO is a software for the exercise of its activity, in the case of Professional Users and / or Supplier of activities, or, for the sale in behalf of those, regarding Users –Agents- Resellers.<br>
            The User, by agreeing with the following terms and conditions, declares that he will not use PLURALO or the services associated with it for any illegal means any unlawful and / or unlawful purposes, fraudulent or unauthorized.
        </p>

        <h3>7.	Prices </h3>
        <p>The use of PLURALO is free.</p>
        <p>PLURALO can charge a subscription or any other type of payment for the use of the Platform. </p>


        <h3>8. Intelectual Property </h3>
        <p>The Users acknowledges that the property and title for all the rights of intellectual property, including the rights for the software, codes, copyrights, trademarks and commercial secrets, are and shall remain the property of PLURALO.
            In the same way for the work flow processes, user interface, designs, know-how and other technologies provided by PLURALO as part of the service, as well as all the rights, titles and interests related to them, including all associated intellectual property rights, are the property of PLURALO.<br>
            The following Terms do not give the User any kind of right to use any brand or logo belonging to PLURALO.<br>
            The User will not copy, translate, disassemble or decompile, nor create or attempt to reverse-engineer or otherwise create the source code and / or platform object.<br>
            The User will not remove any kind of confidentiality or property warning.<br>
            PLURALO grants, within the reasonable knowledge that it has, that it will not violate the intellectual property rights of third parties.<br>
            All the rights not expressly provided for and listed in this Clause are reserved to PLURALO, and cannot be interpreted in any other way at any time, and, in case of doubt, Always be interpreted as meaning that the use in doubt is expressly prohibited by PLURALO.<br>

            The following actions are expressly prohibited to the User:
            <li>Sell, Resell, redistribute, sublicense or rent the platform, unless an agreement with PLURALO says the opposite. </li>
            <li>Use the platform to store or transmit illegal material.</li>
            <li>Use the platform to store or transmit material that violate third parties rights.</li>
            <li>Interfere with or disrupt the integrity or performance of the services;</li>
            <li>Seek unauthorized access to the platform and / or its computer systems;</li>
            <li>Decompile, disassemble or reverse engineer the platform;</li>
            <li>Seek to obtain the source code, modify, decrypt, or create derivative works of the platform or any services provided under this Agreement;</li>
            <li>Access or use the platform to build a competing product and / or service, or copy any feature or graphic for competing purposes;</li>

            If the User break any of the above provisions, in addition to the right of PLURALO to immediately terminate this Agreement, you agree to indemnify PLURALO in an amount not lower than € 250,000.00 (two hundred and fifty thousand euros) , without
            such amount precluding the right to request additional compensation in court for damages, such as compensation payed to third parties and expenses with courts and forensic representation;

        </p>





        <h3>9. Personal Information and Privacy Policy</h3>

        <p>The processing of personal information within the data protection is controlled by the Privacy Policy of PLURALO and it should be consulted for this purpose.</p>
        <p>The User cannot use software tools for the purpose of gathering personal information, namely, robots, crawlers, or other types of automatic mechanisms.</p>


        <h3>10. Security</h3>
        <p>The User is responsible for buying, maintenance, and payment of the licenses needed for the hardware/software he uses to access PLURALO.
            PLURALO will take the necessary technological measures aimed at the effective protection of computer systems and hardware, namely, virus, worms, Trojan horses, spywares and other type of harmful software.<br>
            If PLURALO fraudulently fails to perform this obligation, it will be liable for any damages that the User may suffer, subject to limitations set in Clause 13.<br>
            The User must use the platform according to the instructions from PLURALO and must respect these Terms and Conditions, committing themselves equally to implement the appropriate security measures to the protection of the systems and services.<br>
            In case of any security breach, regardless whether the security and integrity of the data and systems of either party is concerned or not, the Party that has knowledge, shall inform the other party of the situation immediately.<br>
            In the event of suspicion that the security breach searched to erase, change, destroy, damage, suppress or turn non-usable or non-accessible programs or computer data, obstruct, prevent, interrupt or disturb the operation of the computer system by introducing, transmitting, deteriorating, damaging, altering, erasing, preventing access or suppression of programs or other computer data or any other form of interference in a computer system or attempting to illegally access/intercept systems, the affected Party must do the respective complaint with the competent authorities.<br>
            The failure to comply with the obligations identified in this Clause leads to the immediate termination of the Agreement.
        </p>


        <h3>11. Services</h3>
        <p>
            During the duration of these Terms and Conditions, PLURALO will ensure to the User the updating and technical support for the use of the platform and associated services.
        </p>

        <p>
            PLURALO ensures that the platform will be up to date, and these updates will result from the maintenance services automatically provided by PLURALO in accordance with the schedule established for the platform evolution. PLURALO ensures to the User
            a technical service by email, in order to provide support and answer requests for clarification regarding the function of the platform. A chat support service is also available, running on business days, from 9:00AM to 1:00PM and from 2:00PM to 6:00PM.
            PLURALO will seek access for a continuous availability basis to the platform, but cannot guarantee that it will occur, which the User accepts, waiving at any compensation due to the absence of availability.
            <br>The User accepts and acknowledges that performance and availability issues may occur as a cause and/or origin:
            <ul>
                <li>Internet congestion, slowdown or general unavailability; </li>
                <li>Unavailability of generic internet services ( DNS servers) due to external attacks;</li>
                <li>Major force events( unpredictable and unavoidable event, unrelated to the control of the parties, which prevents, totally or partially, permanently or temporarily, from achieving their objectives and fulfilling their obligations on the contractual dates and deadlines such as the state of war, declared or not, rebellions or riots, natural disasters such as fires, floods and earthquakes and communications cuts) </li>
                <li>User or third parties actions or omissions outside of the control of PLURALO;</li>
                <li>As a result of the computer system of the User or third parties;</li>
                <li>The maintence of the platform programmed by PLURALO, as well as updates that may occur.</li>
            </ul>
        </p>

        <h3>12. Communication</h3>
        <p>
            By accepting these Terms and Conditions, the User accepts that the notifications that are made by PLURALO within the scope of the services are made electronically to the email address indicated by the User in its registration.
            <br> The User may contact PLURALO through the email geral@pluralo.com.
        </p>


        <h3>13. Disclaimer of warranties; Limitation of Liability </h3>
        <p>
            The User agrees that PLURALO has no responsibility, direct or indirect, for the use that the User makes of the platform, being the sole and exclusive responsibility of the use of it.<br>
            PLURALO is provided “as it is” for its use, and no representation, warranty or condition of any kind, expressed of implied, including implied warranties as to the conditions of merchantability , commercial quality, suitability for a specific purpose, durability, title and a non-infringement of rights.<br>
            The User accepts that in no case will PLURALO, its corporate bodies, employees, partners, agents, and service providers be liable for any direct, indirect, incidental, punitive or any other damages, losses, claims or damages, including, without limitation loss of profits, loss of revenue, loss of data, replacement costs, or any similar damages, whether based on contact, unlawful act with or without intent, arising out of or related to the platform or any services purchased using PLURALO, including but not limited to any errors or omissions in any content posted, transmitted, or otherwise made available through the platform, and in the latter case and if so decided by the competent court. PLURALO’s liability shall be limited to the annual amount paid by the User for the use of the platform.<br>
            The Failure to require, at any time, User’s compliance with any of its contractual obligations established here, does not imply a waiver of any rights, nor does it constitute the acquisition of a right by the User.
        </p>

        <h3>14. Declarations and Warranties </h3>
        <p>
            It any provision of these Terms and Conditions is declared by an unlawful, void or ineffective jurisdiction, such provision shall be replaced, in whole or in part, by another that is executable, so as to best reflect the terms of the Clause in question.<br>
            The User agrees to guarantee PLURALO’s position, and defends i, as wll as its social bodies, employees, partners, agents, and service providers, from any claim or demand made by any third party due to or arising out their violation of these Terms and Conditions or policies that are part of the operation of PLURALO, as well as the violation of any laws or third party rights.<br>
            The Failure to require, at any time, User’s compliance with any of its contractual obligations established here, does not imply a waiver of any rights, nor does it constitute the acquisition of a right by the User.
        </p>


        <h3>15. Resolution </h3>
        <p>Both Parties may terminate the Terms and Conditions immediately, upon writing a notice to the contrary party.
            <br>PLURALO will consider that the User has resolved the Terms and conditions when there is no use of the platform for a period of 12 (twelve) consecutive months.
            <br>PLURALO can terminate the contract without any warning if the User :

            <li>Commits a violation to these Terms and Conditions;</li>
            <li> Fails to comply with any obligation that may prevent or materially affect these Terms and Conditions;</li>
            <li> Violate any intellectual property rights from PLURALO.</li>
            The immediate resolution of the Terms and Conditions implies that the associated account is canceled and consequently the access is denied.
        </p>

        <h3>16. Integral Agreement</h3>
        <p>The Terms and Conditions, including their policies, constitute the entire agreement between you and PLURALO with respect to the use of the platform associated services.
            Their Policies are an integral part of the Terms and Conditions and cannot be divided.<br>
            The entry of new Policies after the date of the Terms and Conditions, will result in the amendment of these Terms and Conditions through their integration.<br>
            In case of contradiction or nonconformity between documents that integrate the Terms and Conditions, these prevail over the Policies.<br>
            PLURALO can, at any moment, actualize, modify or substitute any of these Terms and Conditions or Policies associated to them, announcing it in the platform homepage, being the User responsible to check this page periodically to be aware of any changes.<br>
            The User acknowledge that the continued use and access to the platform after any updates, modifications or substitutions to the Terms and Conditions, constitutes acceptance and agreement with such updates, modifications or substitutions.
        </p>

        <h3>17. Limitation of liability</h3>
        <p>
            The Terms and Conditions, as well as the associated Policies, are governed by the applicable provisions of the Portuguese Law.<br>
            For the resolution of any litigation arising from the Terms and Conditions, as well as the associated Policies, if not settled by agreement, exclusive jurisdiction is assigned to the District Court of Albufeira, expressly renouncing any other, unless it overlaps by the virtue of law.
        </p>


        <h2>PART II – SPECIFIC CONDITIONS</h2>
        <h3>SERVICE PROVIDER</h3>
        <h3>Service Provider Profile Creation</h3>
        <p>Users can create profiles of Service Providers (Profession/Company), where they can identify all the service they provide.</p>
        <p>
            The creation of a Service Provider profile allows the User to access to a set of functionalities such as:
            <li>Create a portfolio with all the provided services</li>
            <li>Invite new Agent Resellers to sell the provided services; </li>
            <li>Manage booking connected with the provided services, and, Control, through a statistic measure: Monthly Sales; Average Sales per Agent Reseller; The occupancy rate of the provided services; and, Other Relevant data for the management of your business. </li>
        </p>

        <p>
            In order to the profile to be eligible to be contracted and public, the User must complete the following fields:
            <li>Professional Profile;</li>
            <li>Provided Services;</li>
            <li>Access URL to the online page;</li>
            <li>Email and Telephone;</li>
            <li>Company Size (Defined by the number of employees)</li>
            <li>Country;</li>
            <li>Timezone;</li>
            <li>Currency; </li>
            <li>Sale channels: </li>
            <li>Picture/Logo;</li>
            <li>Description of the company and services provided.</li>


            <p>PLURALO does not validate the correctness and accuracy of the data.</p>
        </p>

        <h3>Obligations of the Service Provider</h3>
        <p>
            By creating and maintaining a Service Provider Profile, the User have to comply with the following obligations:
            <li>The User is solely responsible for the accuracy or his/her data, namely, for billing purposes and have to keep them up to date.</li>
            <li>The User cannot book with non-platform Agents;</li>
            <li>The User is the only responsible for the place and equipment used in the services;</li>
            <li>The user is the only responsible for all occurrences during the provision of the services.</li>
        </p>





        <h3>Profile Cancellation</h3>
        <p>
            The User can cancel your profile through the specific tool in the user area. If you cancel the profile, it will no longer be visible in PLURALO and you will lose all the registered data.
        </p>

        <h3>PLURALO and the Service Provider</h3>
        <p>
            PLURALO has the right to limit its services, in particular at a geographical or agent level. The mentioned right will be exercised on a case-by-case basis and this limitation will be communicated in its proper place.<br>
            PLURALO may limit the services offered, namely due to logistical or legal restrictions.<br>
            PLURALO has the right to discontinue any service at any time.<br>
            PLURALO may refuse, limit or cancel ay service, always seeking to inform the Service Provider through its electronic contact or by telephone provided at the time of registration.
        </p>

        <h3>Publicity</h3>
        <p>
            The User Accepts that some of the services made available through PLURALO may be supported by advertising revenue, and therefore advertisements and promotions may be displayed, finding the form, mode and scope of the advertising subject to changewithout specific notice.<br>
            The User also accepts, acknowledges and authorizes that his/her profile may be shared and used for the promotional purposes of PLURALO, renouncing any compensation for such use.
        </p>


        <h3>Tools and Third Parties Connections</h3>
        <p>
            If the platform provides access to thrid-Party tools and the User freely chooses to use them, PLURALO will not monitor them or have any control over them, other than those expressly provided under the conditions of use and that the User accepts, the owners of these tools are the only responsible for all the use, monitoring and/or control that occurs in them.<br>
            The User acknowledges that, under the terms of the previous number, acceptance and access to such tools is provided “ as it is” and “as available”, without any warranties, representations or conditions of any kind, and PLURALO shall be exempt from all liabilities arising out of or relating to the use of the optional third party tools, and consequently any and all uses are made at the user risk.<br>
            If any content and services available through the platform include links to third party sites not affiliated with Platform, the User acknowledge that PLURALO is not, and cannot be held liable since it cannot, examine and evaluate all content or accuracy of links not provided by PLURALO, thus not having any obligation or liability derived from any situations or occurrences.<br>
            The User acknowledges that PLURALO is not responsible for any damages or losses related to the purchase or use of services or any other transactions made in third party sites, and it is the user’s responsibility to use these sites carefully, particularly through careful reading of the policies and conditions therein, and consequently any and all the claims or questions relating to these sites should be forwarded to such third parties.
        </p>

        <h3>Personal Information and Privacy Policy</h3>
        <p>
            The treatment of personal information within the scope of data protection is governed by the Privacy Policy of the Platform and should be consulted for this purpose.<br>
            The User commits itself to not use software tools to collect information of a personal nature, such as robots, crawlers or other automatic mechanisms.
        </p>

        <h3>AGENT RESELLER</h3>
        <h3>Agent Reseller Profile Creation </h3>
        <p>Users can create Agent Resellers profiles to access the services they wish to sell to end consumers.
            <br>Through his/her profile, the Agent Reseller can:
            <li>Receive invitations/proposals from users of Providers;</li>
            <li>Schedule directly the sold services, according to the availability of the provider;</li>
            <li>Calculate the final price of the services sold and the charged commission; and,</li>
            <li>Manage the bookings made for each service.</li>
        </p>

        <p>
            To create the Agent Reseller profile, you must complete the following fields with the following information:<br>
            <li>Name/Firm;</li>
            <li>Photography/Company logo;</li>
            <li>Company Size (Defined by the number of employees);</li>
            <li>Sales Channel;</li>
            <li>Country;</li>
            <li>Country;</li>
            <li>Currency;</li>
            <li>Email and telephone;</li>
        </p>

        <p>PLURALO does not validate the correctness and accuracy of the data.</p>

        <h3>Obligations of the Agent Reseller</h3>
        <p>When creating and maintaining a Agent Reseller profile, the User must comply with the following obligations: <br>
            <li>The User is the only responsible for the correctness and accuracy of the data and have to keep them updated;.</li>
            <li>The User may not seek to make direct bookings with the Users of Service outside the Platform;</li>
            <li>The User is responsible for complying with the cancellation and other rules of the Services, complying with the instructions of the Provider. </li>
        </p>


        <h3>Schedule of Services</h3>
        <p>
            The Agent Reseller may directly schedule services with a Provider, with whom is has entered a partnership through PLURALO, being granted full access to the portfolio of services offered and their availability for scheduling purposes.<br>
            For the purposes of booking tickets, the following data shall be made available by the Agent Reseller to the Provider:
            <li> Scheduled Service;</li>
            <li> Number of persons related to the booking;</li>
            <li>Client Name;</li>
            <li>Client Country; </li>
            <li>Client email and telephone number;</li>
            <li>Customer’s place of accommodation; </li>
            <li>Method of payment.</li>
        </p>

        <h3>Profile Cancellation</h3>
        <p>
            The Agent Reseller may suspend of cancel his/her profile through a specific tool in the User area. If the User cancels the profile, it will no longer be visible on the Platform and all the data will be lost.
        </p>

        <h3>PLURALO and the Agent Reseller </h3>
        <p>
            PLURALO has the right to limit services, in particular at the geographical or customer level. The mentioned right will always be exercised on a case-by-case basis, and this limitation will be communicated in its proper place.<br>
            PLURALO may limit the services offered namely due to logistical or legal restrictions.<br>
            PLURALO has the right to discontinue any service at any time.<br>
            PLURALO may refuse, limit or cancel any service, always seeking to inform the Agent Reseller through its email or telephone number provided upon registration.
        </p>

        <h3>Personal Information and Privacy Policy </h3>
        <p> The processing of personal information within the scope of data protection is controled by the Privacy Policy of the Platform and should be consulted for this purpose.
            <br>The User commits itself not to use software tools to collect personal information, such as robot, crawlers or other automatic mechanisms.
        </p>

        <h3>Advertisement </h3>
        <p>
            The User accepts that some of the services made available through PLURALO may be supported by advertising revenue, and therefore advertisements and promotion may be displayed, and the form, manner and extent of the advertising subject to change without specific notice can be found.<br>
            The User also accepts, acknowledges and authorizes that his/her profile may be shared and user for the promotion purposes of PLURALO, renouncing any compensation for such use.
        </p>


        <h3>PART III – TECHNICAL SPECIFICATIONS AND SPECIFIC FEATURES OF PLURALO</h3>
        <p>PLURALO supports the following specific functionalities:
            <h4>Service Providers</h4>
            <p>
                <li>The inventory area where resource data, pickup routes, services are collected, and the products are configured and scheduled;</li>
                <li>Integration with Primavera billing system, in order to communicate the data for issuing invoices and credit notes;</li>
                <li>Edit events and notify by email the customer who provided the email in the reservation about changes to the event;</li>
                <li>Make reservations, collecting personal data such as Name, email, telephone, country and place of accommodation of the customer;</li>
                <li>Children’s age when children tickets are reserved;</li>
                <li>Place notes in the booking, add extras services, mark location and pickup time (for internal information), consult the details of a booking with customer details, pickup, extra services, agent commissions and check-ins and no-shows;</li>
                <li>Adding receipts and exits of payments.</li>
                <li>Cancel and Rebook bookings;</li>
                <li>When bookings are made in behalf of a Agent reseller they will be available on both the Agent Reseller Platform and on the service provider.</li>
                <li>General reports on statistical data on total sales, occupancy rates, commissions per agent or group of agents.</li>
                <li>Create Agent Reseller accounts, enter an agent’s billing and company data, and see commissions and deposit rules.</li>

            </p>


            <h4>Agent Resellers</h4>
            <p>
                <li>Consult the products of the companies that the Agent Reseller have permission to sell.</li>
                <li>Make reservations (on behalf of a company) by entering the details of a customer.</li>
                <li>Send a copy of the ticket to the customer’s email</li>
                <li>Consult the list of booking and see the detail of the client.</li>
                <li>Issue general sales reports</li>
                <li>Issue widgets that can be integrated into websites.</li>
            </p>

            <h4>Customers</h4>
            <p>
                The Widget is a feature that allows companies and Agent resellers to generate a booking widget whose code can be embedded on any platform. The Booking widget allows any costumer to make a reservation and pay directly. The booking information is immediately
                communicated to the Agent Reseller/Service Provider Platform when successfully completed.
                <li>Allows to search for products, availability and prices per event.</li>
                <li>Request detail data of the client making the booking.</li>
                <li>Request billing details.</li>
                <li>Issue a copy of the electronic ticket to the email</li>
                <li>Communicate the details of the ticket with the platform of the company that provided the service</li>
                <li>When booked by the Agent Reseller, communicates with the platform of the company and the Agent Reseller.</li>
                <li>Request credit card details.</li>
                <li>The payment is processed by the Stripe Platform. The credit card details are not registered in PLURALO data base.</li>

            </p>
        </p>

        <p>
            The User declares that he has read and understood these Terms and Conditions, as well as the Policies associated with it and the specific conditions, and that he has had the opportunity to seek legal advice before accepting it. He further acknowledge that this Agreement is the complete and exclusive statement of the relationship between the User and PLURALO and that derogates from any prior proposal or agreement.
        </p>
        <h5>Version 0.0.1 - 06 Junho 2018</h5>



    </div>
</template>

<script>
  export default {

  }
</script>

<style scoped lang="scss">
  h1 {
    padding: 1.2rem 0 0.5rem;
  }

  h2 {
    padding: 1.1rem 0 0.5rem;
  }

  h3 {
    padding: 1rem 0 0.5rem;
  }

  h4 {
    padding: 0.9rem 0 0.5rem;
  }

  h5 {
    padding: 0.8rem 0 0.5rem;
  }

  table {
    margin-top: 1rem;
  }
</style>



// WEBPACK FOOTER //
// Conditions_en.vue?b4da6f78